/** @format */

import { Text } from "@chakra-ui/react";
import runes from "runes";

export function Observacao({ observacao }) {
  return (
    <>
      {observacao ? (
        <Text color="#555861" fontSize="0.625rem">
          {observacao.length > 35
            ? runes.substr(observacao, 0, 35) + "..."
            : observacao.length <= 35
            ? `${observacao}`
            : observacao}
        </Text>
      ) : (
        <Text>⠀</Text>
      )}
    </>
  );
}
